/**
 * The Individual Row for the catalog items list
 */
import React from 'react';
import PropTypes from 'prop-types';
import TableCell from '../ReusableComponents/Table/TableCell';
import TableRow from '../ReusableComponents/Table/TableRow';
import styles from './FnCatalog.module.css';
import formatDate from '../../Lib/Utils/Date/format-date';
import { catalogItemShape } from './_common_/propTypes';
import Checkbox from '../ReusableComponents/Checkbox/Checkbox';
import SelectInput from '../ReusableComponents/SelectInputV2/SelectInput';
import DimensionsStatus from './DimensionsStatus/DimensionsStatus';

export default function FnCatalogTableRow({
  catalogItem,
  onDimensionOpen,
  onItemCheck,
  onUpdateItem,
  loading = false,
  perms,
}) {
  const isKidsProduct = catalogItem?.division?.toLowerCase() === "kid's";
  const handleProp65Change = ({ target: { value } }) => {
    const newValue = value === 'Yes';
    if (catalogItem.prop65 !== newValue && !isKidsProduct) {
      onUpdateItem({ ...catalogItem, prop65: newValue });
    }
  };

  const formatProp65value = (value) => {
    if (value === true) {
      return 'Yes';
    }
    if (value === false) {
      return '';
    }
    return '';
  };

  return (
    <TableRow>
      <TableCell padding="normal" align="left">
        {perms.canUpdateProps && (
          <Checkbox
            color="secondary"
            className={styles.checkboxRow}
            onChange={() => !isKidsProduct && onItemCheck(catalogItem)}
            checked={catalogItem.checked || false}
            disabled={isKidsProduct}
          />
        )}
      </TableCell>
      <TableCell padding="normal" align="left" className={styles.prop65Cell}>
        <SelectInput
          name="prop65_field"
          disabled={loading || !perms.canUpdateProps || isKidsProduct}
          native
          value={formatProp65value(catalogItem.prop65)}
          onChange={handleProp65Change}
          autoComplete="no"
          noDefault
          options={[
            { value: 'Yes', text: 'Yes' },
            ...(catalogItem.prop65 === null || catalogItem.prop65 === false
              ? [{ value: '', text: '-' }]
              : []),
          ]}
        />
      </TableCell>
      <TableCell padding="normal" align="left">
        {catalogItem.sku}
      </TableCell>
      <TableCell padding="normal" align="left">
        {catalogItem.size}
      </TableCell>
      <TableCell padding="normal" align="left" className={styles.detailCell}>
        <DimensionsStatus
          perms={perms}
          catalogItem={catalogItem}
          onDimensionOpen={onDimensionOpen}
        />
      </TableCell>
      <TableCell padding="normal" align="left">
        {formatDate(catalogItem.last_po_receipt_date)}
      </TableCell>
      <TableCell padding="normal" align="left">
        {catalogItem.division}
      </TableCell>
      <TableCell padding="normal" align="left">
        {catalogItem.wms_id}
      </TableCell>
    </TableRow>
  );
}

FnCatalogTableRow.propTypes = {
  catalogItem: catalogItemShape.isRequired,
  onDimensionOpen: PropTypes.func.isRequired,
  onItemCheck: PropTypes.func.isRequired,
  onUpdateItem: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  perms: PropTypes.shape({
    canUpdateProps: PropTypes.bool,
    canUpdateSizeAndWeight: PropTypes.bool,
  }).isRequired,
};
